import withTranslation from 'framework/components/hoc/withTranslation';
import Text from './Text';

export default withTranslation(Text);
